import { combineEpics, Epic, ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    changePricePackagesColumnsOrderData,
    changePricePackagesColumnsVisibilityData,
    HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE,
    HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE,
    HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE,
    HandlePricePackagesColumnsOrderChangeAction,
    HandlePricePackagesColumnsVisibilityChangeAction,
    HandlePricePackagesColumnsWidthUpdateAction,
    updatePricePackagesColumnsWidthData
} from '../../actions/pricePackages';
import {
    getColumnSettingsWithUpdatedOrder,
    getColumnsVisibilitySettings,
    getColumnsWidthSettings
} from '../../service/ActionHelpers';
import { LocalStorage, StorageKeyType } from '../../service/Storage/Storage';
import { EpicDeps } from '../../service/StoreFactory';
import { deals, pricePackages } from '../../typings/common';
import { State } from '../../typings/state';

export const handlePricePackagesColumnsVisibilityChangeEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.pipe(
        ofType(HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE),
        map(
            (action: HandlePricePackagesColumnsVisibilityChangeAction): Action => {
                const { columnsSettings } = store$.value.pricePackages;
                const settings = getColumnsVisibilitySettings(columnsSettings, action.columns, pricePackages);

                LocalStorage.setItem(StorageKeyType.pricePackagesColumnsSettings, settings);

                return changePricePackagesColumnsVisibilityData(settings);
            }
        )
    );
};

export const handlePricePackagesColumnsWidthUpdateEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE),
        map(
            (action: HandlePricePackagesColumnsWidthUpdateAction): Action => {
                const { columnsSettings } = store$.value.pricePackages;
                const settings = getColumnsWidthSettings(
                    columnsSettings,
                    action.key,
                    action.width,
                    pricePackages,
                    true
                );

                LocalStorage.setItem(StorageKeyType.pricePackagesColumnsSettings, settings);

                return updatePricePackagesColumnsWidthData(settings);
            }
        )
    );
};

export const handlePricePackagesColumnsOrderChangeEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE),
        map(
            (action: HandlePricePackagesColumnsOrderChangeAction): Action => {
                const { columnsSettings } = store$.value.pricePackages;
                const settings = getColumnSettingsWithUpdatedOrder(columnsSettings, action.columnOrder, pricePackages);

                LocalStorage.setItem(StorageKeyType.pricePackagesColumnsSettings, settings);

                return changePricePackagesColumnsOrderData(settings[deals].columnOrder);
            }
        )
    );
};

export const pricePackagesHelpersEpic = combineEpics(
    handlePricePackagesColumnsWidthUpdateEpic,
    handlePricePackagesColumnsVisibilityChangeEpic,
    handlePricePackagesColumnsOrderChangeEpic
);
